<div class="mainSection">
    <div class="creditDesc">
        <p class="descHeader d-flex justify-content-between"><span class="headerText">Turn Off Credit Reporting?</span>
            <button type="button" class="close" aria-label="Close" role="button_close" (click)="dialogRef.close()"><img
                src="assets/svg/close-circle.svg" alt=""></button>
            </p>
            <span>Without reporting, your on-time payments for this plan aren’t sent to the credit bureaus and won’t help build credit history.</span>
    </div>
    <div class="buttonsSection">
        <button class="credit_button" (click)="dialogRef.close({selection:true})">Keep Credit Reporting</button>
        <button class="credit_button cancelButtonCredit" (click)="dialogRef.close({selection:false})">Turn Off Anyway</button>
    </div>

</div>
